export const RAW_PROD_TYPE_CODE_LABELS = {
  A: 'Sub-assembly',
  G: 'Generic Ingredient',
  M: 'Miscellaneous',
  N: 'Not Inventorized',
  P: 'Premium Item',
  R: 'Raw Product',
  S: 'Specific',
  T: 'Raw Product Used as a Pizza Topping',
};

export type RawProdTypeCodeKeys = keyof typeof RAW_PROD_TYPE_CODE_LABELS;

export enum RAW_PROD_TYPE_CODE {
  'SubAssembly' = 'A',
  'GenericIngredient' = 'G',
  'Miscellaneous' = 'M',
  'NotInventorized' = 'N',
  'PremiumItem' = 'P',
  'RawProduct' = 'R',
  'Specific' = 'S',
  'UsedAsPizzaTopping' = 'T',
}

export const RAW_PROD_PCA_NUMBER = {
  0: 'Non Pizza',
  1: 'Food',
  2: 'Topping',
  3: 'Cheese',
  4: 'Paper',
};

export type RawProdPcaNumberKeys = keyof typeof RAW_PROD_PCA_NUMBER;

export const RAW_PROD_UOM = {
  1: 'Ounces',
  2: 'Slices',
  3: 'Each',
  4: 'Can',
  5: 'Jar',
  6: 'Lb.',
  7: 'Bag',
  8: 'Btle',
  9: 'Tube',
  10: '6pack',
  11: 'Keg',
  12: 'Batch',
  13: 'Gains',
  14: 'Pack',
  15: 'Tray',
  16: 'Gal',
  17: 'H/gal',
  18: 'Litre',
  19: 'Case',
  20: 'Sheet',
  21: 'Disk',
  22: 'Pouch',
  23: 'Tub',
  24: 'Box',
  25: 'Pint',
  29: 'Head',
  30: 'Pail',
  31: 'Cs 1M',
  37: 'Bundle',
  38: 'Cup',
  39: 'Piece',
  40: 'Bunch',
  41: 'Loaf',
  42: 'Jug',
  43: 'Quart',
};

export type RawProdUomKeys = keyof typeof RAW_PROD_UOM;

export const RAW_PROD_USAGE_ALGO = {
  ACTUAL: 'Actual',
  IDEAL: 'Ideal',
  MISC: 'Misc',
  NONE: 'None',
};

export type RawProdUsageAlgoKeys = keyof typeof RAW_PROD_USAGE_ALGO;
